module.exports = __webpack_public_path__ + "static/media/wifi.01a1ca07.jpg";